<template>
  <div>
    <el-dialog
      top="5vh"
      v-loading="loading"
      title="选择收费标准"
      :visible.sync="dialogVisible"
      width="530px"
      :before-close="handleClose">
      <el-input placeholder="输入关键字快速查询" v-model="filterText"></el-input>
      <span style="color: red;" v-if='text'>{{text}}</span>
      <div style="height: 60vh;overflow-y: auto;margin-top: 5px;">
        <el-tree class="filter-tree" @node-click='trees' node-key="id" :data="data" :props="defaultProps" :default-expanded-keys="[0]" :filter-node-method="filterNode" ref="tree"></el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="$emit('chargeAdd')">确 定</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
  export default {
      // 接受父组件的值
      props: {

      },
      watch: {
        filterText(val) {
          this.$refs.tree.filter(val);
        }
      },
      data () {
        return {
          text:'',
          filterText:'',
          dialogVisible:false,
          select:{
            pay:'',
            house:'',
            name:'',
            date:'',
            chargeitem_id:[],
            frozen:"未冻结"
          },
          loading:false,
          data: [],
          defaultProps: {
            children: 'children',
            label: 'label',
          },
          charge_list:[]
        }
      },
      mounted(){

      },
      //事件
      methods: {
        //节点被点击
        trees(e,v,s){
          this.charge_list = e;
        },
        //返回数据
        treeRetrue(){
          this.text = '';
          if(!this.charge_list.charge){
            this.text = '请选择第三级，收费标准!';
            return false;
          }
          this.dialogVisible = false;
          return this.charge_list;
        },
        getInvo(pid){
          this.dialogVisible = true;
          this.$myhttp.get('admin/Temporary/charge_tree?pid='+pid,{
            'Content-Type': 'application/json'
            }).then(backdata=>{ // 异步执行成功后
              this.data = backdata.data.data
              console.log(this.data);
          });
        },
        handleClose(done) {
          done();
        },
        filterNode(value, data) {
          if (!value) return true;
          return data.label.indexOf(value) !== -1;
        }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/temporary/charge.vue